import {
  type CellContext as CellContextCore,
  type ColumnDef as ColumnDefCore,
  columnFilteringFeature,
  type ColumnMeta as ColumnMetaCore,
  columnSizingFeature,
  columnVisibilityFeature,
  createColumnHelper as createColumnHelperCore,
  globalFilteringFeature,
  type HeaderContext as HeaderContextCore,
  type ReactTable,
  type RowData,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from "@tanstack/react-table";

// Bound once so the column helper's features match the table's; a mismatch makes defs non-assignable.
export const dataTableFeatures = tableFeatures({
  columnFilteringFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  globalFilteringFeature,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
});

export type DataTableFeatures = typeof dataTableFeatures;

export const createColumnHelper = <TData extends RowData>() => createColumnHelperCore<DataTableFeatures, TData>();

export type ColumnDef<TData extends RowData, TValue = unknown> = ColumnDefCore<DataTableFeatures, TData, TValue>;
export type CellContext<TData extends RowData, TValue = unknown> = CellContextCore<DataTableFeatures, TData, TValue>;
export type HeaderContext<TData extends RowData, TValue = unknown> = HeaderContextCore<
  DataTableFeatures,
  TData,
  TValue
>;
export type ColumnMeta<TData extends RowData, TValue = unknown> = ColumnMetaCore<DataTableFeatures, TData, TValue>;
export type Table<TData extends RowData> = ReactTable<DataTableFeatures, TData>;
